import Ranking from "../types/Ranking";
import * as config from "../config";
import OverallStandings from "../types/OverallStandings";
import OwnContribution from "../types/OwnContribution";

const baseUrl = "https://europe-west1-mysper-e5462.cloudfunctions.net";

export async function getOverallStandings(locale: string): Promise<any> {
  let url =
    baseUrl + "/getOverallStandings?competitionId=" + config.COMPETITION_ID;

  if (locale) {
    url += "&locale=" + locale;
  }

  const requestOptions: RequestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
  };

  try {
    console.log("getOverallStandings", url)
    const response = await fetch(url, requestOptions);
    const json = await response.json();
    console.log("getOverallStandings", json);
    return json as { overallStandings: OverallStandings };
  } catch (e) {
    console.log(e);
  }
  return null;
}

export async function getOwnContribution(
  userId: string | null,
  teamId: string | null,
  teamIds: string | null
): Promise<any> {
  if (!userId) {
    return null;
  }

  let url =
    baseUrl +
    "/getOwnContribution?competitionId=" +
    config.COMPETITION_ID +
    "&userId=" +
    userId;

  if (teamIds) {
    url += `&teamIds=${teamIds}`;
  } else if (teamId) {
    url += `&teamId=${teamId}`;
  }

  const requestOptions: RequestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
  };

  try {
    console.log("getOwnContribution", url)
    const response = await fetch(url, requestOptions);
    const json = await response.json();
    return json as { ownContribution: OwnContribution };
  } catch (e) {
    console.log(e);
  }
  return null;
}

export async function getTeamsRanking(
  teamId?: string | null,
  teamIds?: string | null
): Promise<Ranking> {
  return await getRanking("teams", "averagePoints", 500, teamId, teamIds);
}

export async function getRanking(
  type: string,
  metric: string,
  maxTeams: number,
  teamId?: string | null,
  teamIds?: string | null
): Promise<Ranking> {
  let url =
    baseUrl +
    "/getRanking?competitionId=" +
    config.COMPETITION_ID +
    "&type=" +
    type;

  url += `&metric=${metric}`;
  url += `&maxTeams=${maxTeams}`;

  if (teamIds) {
    url += `&teamIds=${teamIds}`;
  } else if (teamId) {
    url += `&teamId=${teamId}`;
  }

  const requestOptions: RequestInit = {
    method: "GET",
    mode: "cors",
    redirect: "follow",
  };

  try {
    const response = await fetch(url, requestOptions);
    const json = await response.json();
    return json as Ranking;
  } catch (e) {
    console.log(e);
  }
  return {
    monthly: [],
    quarterly: [],
    highlighted: [],
  };
}
